<template>
  <nav
    style="
      box-shadow: 0 1px 0 rgba(219, 219, 219, 0.3);
      display: flex;
      justify-content: space-between;
      padding: 2px;
    "
  >
    <div>
      <div id="mySidenav" class="sidenav">
        <a href="javascript:void(0)" class="closebtn" @click="closeNav()"
          >&times;</a
        >
        <a style="text-align: start">
          <div id="logo">
            <img
              :src="
                'https://apppanterafood.com.br/DeliveryCenter/' +
                retornaContrato +
                '/logo/logo.png'
              "
              alt="Bulma logo"
              height="200px"
              width="200px"
            />
          </div>
          <a
            style="color: #fff"
            v-if="logado == true && (cadastro == '0' || cadastro == '1')"
            >{{ nome }}</a
          >
          <hr />
          <a style="color: #fff" @click="closeNav()">
            <router-link to="/" style="color: #fff; padding: 0px"
              >Cardápio</router-link
            >
          </a>
          <a
            style="color: #fff"
            v-if="
              logado == false &&
              (cadastro == '0' || cadastro == '1' || cadastro == '3')
            "
            @click="closeNav()"
          >
            <router-link to="/login" style="color: #fff; padding: 0px"
              >Login</router-link
            >
          </a>
          <a
            style="color: #fff"
            v-if="
              logado == false &&
              (cadastro == '0' || cadastro == '1' || cadastro == '3')
            "
            @click="closeNav()"
          >
            <router-link to="/cadastro" style="color: #fff; padding: 0px"
              >Cadastra-se</router-link
            >
          </a>
          <a
            style="color: #fff"
            v-if="
              logado == true &&
              (cadastro == '0' || cadastro == '1' || cadastro == '3')
            "
            @click="sair(), limparCache()"
            >Sair</a
          >
          <!-- <a
            style="color: #fff"
            v-if="logado == true"
            @click="closeNav(), pushEnderecos()"
          >
            Endereços de entrega
          </a> -->
          <a
            style="color: #fff"
            v-if="logado == true && (cadastro == '0' || cadastro == '1')"
            @click="closeNav()"
          >
            <router-link to="/email" style="color: #fff; padding: 0px"
              >Alterar email</router-link
            >
          </a>
          <a
            style="color: #fff"
            v-if="logado == true && cadastro == '0'"
            @click="closeNav()"
          >
            <router-link to="/senha" style="color: #fff; padding: 0px"
              >Alterar senha</router-link
            ></a
          >
          <a style="color: #fff" @click="closeNav()">
            <router-link to="/sobre" style="color: #fff; padding: 0px"
              >Sobre</router-link
            >
          </a>
        </a>
      </div>
      <span style="font-size: 30px; cursor: pointer" @click="openNav()"
        >&#9776;</span
      >
    </div>
    <!--<img src="../assets/logo.png" alt="Bulma logo">-->
    <!-- <div id="logo">
      <router-link to="/" class="nav-item">
        <img
          src="https://apppanterafood.com.br/DeliveryCenter/3/logo/logoqr.png"
          alt="Bulma logo"
        />
      </router-link>
    </div> -->

    <!-- <div class="link">
      <div class="nav-item">
        <router-link to="/" class="nav">
          <b style="font-size: 1.5rem" class="cor-preta form-inline">
            Cardápio
          </b>
        </router-link>
      </div> -->
    <div style="display: flex; justify-content: center">
      <div style="display: flex; align-items: center; margin-right: 5px">
        <div class="field is-grouped">
          <p class="control">
            <router-link to="/cart" class="button is-black">
              <span class="icon">
                <i class="fa fa-shopping-cart"></i>
              </span>
              <span>Carrinho ({{ itemsInCart }})</span>&nbsp;<br />
            </router-link>
          </p>
        </div>
      </div>

      <!--     <div class="nav-item form-inline">
        <span

          class="button is-black botaoAbertoFechado"
          style="color: #ffffff; background-color: #28a745"
          v-on="storage()"
          type="text"
          >{{storageAux}}</span>
      </div> -->
      <div style="display: flex; align-items: center">
        <span
          class="button is-black botaoAbertoFechado"
          style="color: #ffffff; background-color: #28a745"
          v-if="inisVL === '1'"
          type="text"
          >Aberto</span
        >
        <span
          class="button is-black botaoAbertoFechado"
          style="color: #ffffff; background-color: #dc3545"
          v-else-if="inisVL === '0'"
          type="text"
          >Fechado</span
        >
      </div>
    </div>
    <!-- </div> -->
  </nav>
</template>

<style lang="scss">
.sidenav {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  background-color: #a9a9a9;
  overflow-x: hidden;
  transition: 0.5s;
  /* padding-top: 60px; */
}

.sidenav a {
  padding: 8px 8px 8px 16px;
  text-decoration: none;
  font-size: 18px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.sidenav a:hover {
  color: #f1f1f1;
}

.sidenav .closebtn {
  position: absolute;
  top: 0;
  right: 25px;
  font-size: 36px;
  margin-left: 50px;
}

@media screen and (max-height: 450px) {
  .sidenav {
    padding-top: 15px;
  }
  .sidenav a {
    font-size: 18px;
  }
  .a {
    justify-content: start;
  }
}
@media (max-width: 858px) {
  .link {
    display: flex !important;
    flex-wrap: wrap;
    display: inline-flex;
    flex-flow: row wrap;
    justify-content: flex-end !important;
    flex-wrap: wrap-reverse;
  }
  .nav-item {
    justify-content: flex-end;
    padding: 0.25rem 0.5rem;
  }
  .botaoAbertoFechado {
    padding-bottom: 15px;
    padding-left: 30px;
    padding-right: 30px;
    padding-top: 15px;
    line-height: 1.5;
    height: 1em;
  }

  /* #aux {
    float: right;
    display: flex;
    flex-wrap: wrap;
    display: inline-flex;
    flex-flow: row wrap;
    justify-content: flex-end;
  }
  #aux2 {
    display: flex;
    flex-wrap: wrap;
    display: inline-flex;
    flex-flow: row wrap;
  } */
}
#navbar {
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: 20% 45% auto;
}
#logo {
  display: grid;
  justify-content: start;
  align-content: center;
}
.link {
  display: grid;
  justify-content: end;
  align-content: center;
  grid-auto-flow: column;
}

.nav {
  height: auto;
  margin-bottom: 2rem;
}

.nav-item img {
  max-height: 3.5rem;
}

.active-bottom-border {
  border-bottom: 3px solid #00d1b2;
  color: #00d1b2;
  padding-bottom: calc(0.75rem - 8px);
}
</style>

<script>
import { mapGetters, mapActions } from "vuex";
import Classe_prod from "../services/classe_prod";
import horario from "../services/horario";
import Horario from "../services/horario";
import Inis from "../services/inis";
import Swal from "sweetalert2";

/* export const dataStore = {
  state: {
    funcionamento: [this.inisVL]
  }
} */
export default {
  name: "NavBar",
  data() {
    return {
      classe_prods: [],
      classe_prod: {
        nm: "",
        ordem: "",
      },
      horarios: [],
      horarioAtual: [],
      horario: {
        cd: "",
        hr_inicial: "",
        hr_final: "",
        ativado: "",
      },
      inisVL: "",
      inis: {
        cd: "",
        vl: "",
        dt_ins: "",
        desc_config: "",
      },
      storageAux: "",
      contrato: "",
      cadastro: "",
    };
  },
  filters: {
    capitalize(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.substr(1).toLowerCase();
    },
  },
  computed: {
    ...mapGetters({
      //adicionais: 'allAdicionais',
      nome: "retornaNome",
      logado: "retornaLogado",
    }),
    retornaContrato() {
      this.contrato = parseInt(localStorage.getItem("contrato"));
      // console.log(localStorage.getItem('contrato'))
      return this.contrato;
    },
    itemsInCart() {
      let cart = this.$store.getters.cartProducts;
      return cart.reduce((accum, item) => accum + item.quantity, 0);
    },
  },
  methods: {
    storage() {
      this.storageAux =
        localStorage.getItem("serie" + localStorage.getItem("contrato")) +
        " - " +
        localStorage.getItem("num_serie" + localStorage.getItem("contrato"));
    },
    listandoInis() {
      var cd = "TIPO_LOGIN";
      Inis.listarInisCd(cd).then((resposta) => {
        this.cadastro = resposta.data[0].vl;
        //console.log(this.cadastro)
      });
    },
    listandoHorarios() {
        this.horarioAtual = this.obterDiaHora()[0]
        var ativado = 1;
        Horario.listarhorario(ativado).then((resposta) => {
          if (resposta.data == null) {
            this.inisVL = "0";
            this.$store.commit("setFuncionamento", "0");
          } else {
            if (resposta.data.length != 0) {
              this.horarios = resposta.data.filter((horario) => {
                if (horario.plataforma == "0" || horario.plataforma == "2") {
                  return horario;
                }
              });
            }
          }
          if (this.horarios.length == 0) {
            this.inisVL = "0";
            this.$store.commit("setFuncionamento", "0");
          } else {
            var horaAtual = parseInt(this.horarioAtual.horario.substring(0, 2));
            var minutoAtual = parseInt(
              this.horarioAtual.horario.substring(3, 5)
            );
            var date = this.horarioAtual.dia;
            var dia = "";

            switch (date) {
              case "Sunday":
                dia = "dom";
                break;
              case "Monday":
                dia = "seg";
                break;
              case "Tuesday":
                dia = "ter";
                break;
              case "Wednesday":
                dia = "qua";
                break;
              case "Thursday":
                dia = "qui";
                break;
              case "Friday":
                dia = "sex";
                break;
              case "Saturday":
                dia = "sab";
                break;
            }

            if (this.horarios == null) {
              this.inisVL = "0";
            } else {
              for (var i = 0; i < this.horarios.length; i++) {
                if (this.horarios[i].dias.includes(dia)) {
                  var inicialHora = parseInt(
                    this.horarios[i].hr_inicial.substring(0, 2)
                  );
                  var inicialMinuto = parseInt(
                    this.horarios[i].hr_inicial.substring(3, 5)
                  );
                  var finalHora = parseInt(
                    this.horarios[i].hr_final.substring(0, 2)
                  );
                  var finalMinuto = parseInt(
                    this.horarios[i].hr_final.substring(3, 5)
                  );
                  //console.log(inicialHora,"inicialHora")

                  if (inicialHora == horaAtual) {
                    if (
                      inicialMinuto < minutoAtual ||
                      inicialMinuto == minutoAtual
                    ) {
                      this.$store.commit("setFuncionamento", "1");
                      this.inisVL = "1";
                      // console.log("aberto 1");
                      break;
                    } else {
                      this.$store.commit("setFuncionamento", "0");
                      this.inisVL = "0";
                      // console.log("fechado 1");
                    }
                  } else if (inicialHora < horaAtual) {
                    if (horaAtual < finalHora) {
                      this.$store.commit("setFuncionamento", "1");
                      this.inisVL = "1";
                      // console.log("aberto2");
                      break;
                    }
                    if (horaAtual == finalHora) {
                      if (minutoAtual < finalMinuto) {
                        this.$store.commit("setFuncionamento", "1");
                        this.inisVL = "1";
                        // console.log("aberto3");
                        break;
                      } else {
                        this.$store.commit("setFuncionamento", "0");
                        this.inisVL = "0";
                        // console.log("fechado 2");
                      }
                    } else {
                      this.$store.commit("setFuncionamento", "0");
                      this.inisVL = "0";
                      // console.log("fechado 3");
                    }
                  } else {
                    this.$store.commit("setFuncionamento", "0");
                    this.inisVL = "0";
                    // console.log("fechado 4");
                  }
                } else {
                  this.$store.commit("setFuncionamento", "0");
                  this.inisVL = "0";
                  // console.log("fechado 5");
                }
              }
            }
          }
        });
    },
    obterDiaHora() {
      // Obtém a data atual
      const dataAtual = new Date();

      // Array para mapear os dias da semana
      const diasSemana = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];

      // Obtém o dia da semana atual
      const diaSemana = diasSemana[dataAtual.getDay()];
      var horas =  dataAtual.getHours()
      var minutos = dataAtual.getMinutes()
      var segundos = dataAtual.getSeconds()

      var horas = horas<10?`0${horas}`:horas
      var minutos = minutos<10?`0${minutos}`:minutos
      var segundos = segundos<10?`0${segundos}`:segundos
      // Formata o horário atual
      const horario = `${horas}:${minutos}:${segundos}`;


      // Retorna um objeto contendo o dia da semana e o horário
      return [
        {
          dia: diaSemana,
          horario: horario,
        },
      ];
    },
    listarclasse() {
      Classe_prod.listarclasse().then((resposta) => {
        this.classe_prods = resposta.data;
        //console.log(this.logado)
        /*         this.horaAtual(); */
      });
    },
    openNav() {
      document.getElementById("mySidenav").style.width = "250px";
    },

    closeNav() {
      document.getElementById("mySidenav").style.width = "0";
    },
    sair() {
      localStorage.removeItem("email" + localStorage.getItem("contrato"));
      localStorage.removeItem("nm" + localStorage.getItem("contrato"));
      localStorage.removeItem("cd" + localStorage.getItem("contrato"));
      this.$store.commit("setLogado", false);

      this.$router.push("/login");
    },
    pushEnderecos() {
      this.$router.push("/enderecos");
    },

    limparCache() {
      localStorage.setItem("logado" + localStorage.getItem("contrato"), "0");
      localStorage.removeItem("email" + localStorage.getItem("contrato"));
      localStorage.removeItem("nm" + localStorage.getItem("contrato"));
      localStorage.removeItem("cd" + localStorage.getItem("contrato"));
    },
    /* calculaHorario() {
      var horaAtual = new Date();
      var localdate =
        horaAtual.getDate() +
        "/" +
        (horaAtual.getMonth() + 1) +
        "/" +
        horaAtual.getFullYear() +
        " " +
        horaAtual.getHours() +
        ":" +
        horaAtual.getMinutes();
      console.log(localdate, "aqui");
      console.log(this.horario.hr_inicial);
      console.log(this.horario.hr_final);
      return localdate;
    }, */
    ...mapActions(["inserirLogin"]),
  },
  mounted() {
    this.listandoInis();
    this.listarclasse();
    this.listandoHorarios();
  },
};
</script>
